import { Button, Grid, makeStyles, MenuItem, TextField } from "@material-ui/core";
import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getAllRoutes, getSortingMachines, getSortingWarehouses, handleSearchItems, handleSortingCenter, querySortingConfigs } from "../../actions/sortingMachineManagementActions";
import sortingModes from '../../constants/sortingModes.json';
import { handleOpenCreateEditSortingMachineDialog, showAlertSnackbar } from "../../reducers/uiSlice";
import FullscreenLoading from "../Common/FullscreenLoading";

const useStyles = makeStyles((theme) => ({
}));

function SearchSection(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { t } = useTranslation('sortingMachineManagement');

    const sortingMachines = useSelector(state => state.smmReducer.sortingMachines);

    const [sortingCenter, setSortingCenter] = useState('');
    const [sortingMachine, setSortingMachine] = useState('');
    const [sortingMode, setSortingMode] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSearch = async () => {
        try {
            setLoading(true);
            await dispatch(querySortingConfigs(sortingMachine, sortingMode));
            await dispatch(getAllRoutes(sortingCenter));
            await dispatch(handleSearchItems(sortingCenter, sortingMachine, sortingMode));
        } catch {
            dispatch(showAlertSnackbar({ message: t('info_fetch_fail'), type: 'error' }));
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (sortingCenter) {
            dispatch(getSortingMachines(sortingCenter));
            dispatch(getSortingWarehouses(sortingCenter));
        }
    }, [sortingCenter])

    return (
        <Grid container>
            <Grid item xs={9} container spacing={1}>
                <Grid item xs={3}>
                    <TextField
                        select
                        fullWidth
                        value={sortingCenter}
                        variant="outlined"
                        onChange={(e) => setSortingCenter(e.target.value)}
                        label={t('sorting_center')}
                    >
                        {
                            props.sortingCenters?.length > 0 &&
                            props.sortingCenters.map((center) => (
                                <MenuItem value={center.id}>{center.name}</MenuItem>
                            ))
                        }

                    </TextField>
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        select
                        fullWidth
                        value={sortingMachine}
                        variant="outlined"
                        onChange={(e) => setSortingMachine(e.target.value)}
                        label={t('sorting_machine')}
                        disabled={!sortingCenter}
                    >
                        {
                            sortingMachines?.length > 0 &&
                            sortingMachines.map((machine) => (
                                <MenuItem value={machine.machine_code}>{machine.machine_code}</MenuItem>
                            ))
                        }
                    </TextField>
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        select
                        fullWidth
                        value={sortingMode}
                        variant="outlined"
                        onChange={(e) => {
                            setSortingMode(e.target.value)
                        }}
                        label={t('sorting_mode')}
                    >
                        {
                            sortingModes.map((mode) => (
                                <MenuItem value={mode.id}>{t(`${mode.name}`)}</MenuItem>
                            ))
                        }

                    </TextField>
                </Grid>
                <Grid item xs={3}>
                    <Button
                        fullWidth
                        color="primary"
                        variant="contained"
                        disabled={!sortingCenter || !sortingMode || !sortingMachine}
                        onClick={handleSearch}
                    >
                        {t('common:search')}
                    </Button>
                </Grid>
            </Grid>
            <Grid item xs={3} style={{ textAlign: 'right', width: '100%' }}>
                <Button
                    color='primary'
                    variant="outlined"
                    onClick={() =>
                        dispatch(handleOpenCreateEditSortingMachineDialog({
                            open: true,
                            type: 'CREATE'
                        }))}
                >
                    {t('add_new')}
                </Button>
            </Grid>
            <FullscreenLoading open={loading} />
        </Grid>
    );
}

export default SearchSection;